import React, { useEffect } from "react";
import { Box, Divider, TextField, Button, Typography, Avatar, Modal, Alert } from "@mui/material";
import MjLabel from "../../components/ui/MjLabel";
import DefaultProfilePic from "../../imgs/user.png";
import MjChip from "../../components/ui/MjChip";
import { useState } from "react";
import { colors } from "../../theme/Colors";
import { useLocation } from "react-router";
import { useAuthContext } from "../../hooks/useAuthContext";
import Api from "../../api/Api";
import { Urls } from "../../api/Urls";
function FicheDePaieDetails() {
  const location = useLocation();
  const [change, setChange] = useState(0);
  const idFiche = location.pathname.split("/")[4];
  const [action, setAction] = useState("");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { user } = useAuthContext();
  const access_token = user?.access_token;

  const [fiche, setFiche] = useState([]);
  useEffect(() => {
    Api.get(Urls.GET_DETAILS_FICHE_DE_PAIE + idFiche, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        setFiche(res.data.fichedepaie);
        console.log(res.data.fichedepaie);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [change]);
  //PAYER FICHE DE PAIE
  const payerFiche = (id) => {
    Api.patch(
      Urls.PAYER_FICHE_DE_PAIE,
      {
        fichedepaie_ids: [idFiche],
      },
      {
        headers: { "content-tyoe": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        console.log(res);
        setChange(change + 1);
        setSuccess("Payée avec succés");
        setError("");
        setTimeout(() => {
          setOpen(false);
          setError("");
          setSuccess("");
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        setError("une erreur est suvenue");
        setSuccess("");
        setTimeout(() => {
          setOpen(false);
          setError("");
          setSuccess("");
        }, 2000);
      });
  };
  const downloadPEM = () => {
    Api.get(Urls.DOWNLOAD_PEM_FILE, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        fichedepaie_ids: [idFiche],
      },
    })
      .then((res) => {
        console.log(res.data);
        const fileData = res?.data;
        const blob = new Blob([fileData], { type: "text/xml" });
        const url = URL.createObjectURL(blob);
        console.log(url);
        const link = document.createElement("a");
        link.download = `${idFiche + fiche?.first_name + fiche?.last_name}.xml`;
        link.href = url;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Box sx={{ maxWidth: "800px" }}>
      {/* Header Section */}
      <Box className="header" sx={{ marginBottom: "1rem" }}>
        <Typography variant="h4" component="h1" mb>
          Gestion des fiches de paie
        </Typography>
        <Typography variant="h5" component="h1">
          Détails de la fiche de paie
        </Typography>
      </Box>
      <Box sx={{ margin: "1rem 0rem" }}>
        <Typography variant="detail_orange">Fiche de paie</Typography>
      </Box>
      <Box sx={{ margin: "1rem 0rem" }}>
        <Typography variant="detail_title">
          {fiche?.first_name ? fiche?.first_name : null} {fiche?.first_name ? fiche?.last_name : null}
        </Typography>
      </Box>
      {/* Liste des fiche de paie section*/}
      <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography>
              Date : <Typography variant="detail_value"> {fiche?.created_at ? fiche?.created_at : null}</Typography>
            </Typography>
          </Box>
          <Box display="flex">
            <Typography sx={{ marginRight: "0.5rem" }}>Etat :</Typography>
            <MjChip name={fiche.is_paid === 1 ? "paid" : "unpaid"} />
          </Box>
        </Box>
        <Divider sx={{ margin: "1rem 0rem", maxWidth: "800px" }} />
        {fiche?.contrats?.map((fact) => (
          <Box key={fact.id}>
            <Box>
              <Typography>
                Mission : <Typography variant="detail_value">{fact?.mission_intitule_poste ? fact?.mission_intitule_poste : "-"}</Typography>
              </Typography>
              <Typography>
                Numéro de contrat : <Typography variant="detail_value">{fact?.id ? fact?.id : "-"}</Typography>
              </Typography>
              <Typography>
                Entreprise : <Typography variant="detail_value">{fact?.entreprise_name ? fact?.entreprise_name : "-"}</Typography>
              </Typography>
              <Typography>
                Nombre d'heures : <Typography variant="detail_value">{fact?.nbr_hours_declared_by_malinjob ? fact?.nbr_hours_declared_by_malinjob : "-"}</Typography>
              </Typography>
              <Typography>
                Montant : <Typography variant="detail_orange">{fact?.montant ? fact?.montant + " €" : "-"}</Typography>
              </Typography>
              <Divider sx={{ margin: "1rem 0rem", maxWidth: "800px" }} />
            </Box>
          </Box>
        ))}
        <Box sx={{ marginBottom: "1rem" }}>
          <Typography variant="detail_orange_large">Total : {fiche?.total} €</Typography>
        </Box>
        <Box display="flex" alignItems="center" sx={{ flexWrap: "wrap" }}>
          <Typography>Etat : </Typography>
          {fiche?.is_paid === 1 ? null : (
            <Button
              onClick={() => {
                setOpen(true);
                setAction("payer la fiche de paie");
              }}
              sx={{ margin: "0.5rem 1rem" }}
              variant="mj_primary"
            >
              Payée
            </Button>
          )}
          <Button onClick={() => downloadPEM()} sx={{ margin: "0.5rem 1rem" }} variant="mj_primary">
            Télécharger le fichier de paiment (PEM)
          </Button>
          <Button onClick={() => window.open(fiche?.file_url, "_blank")} sx={{ margin: "0.5rem 1rem" }} variant="mj_primary">
            Télécharger la fiche de paie
          </Button>
        </Box>
      </Box>
      <Modal sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} open={open} onClose={() => setOpen(false)}>
        <Box width="350px" sx={{ backgroundColor: "white", borderRadius: "10px" }}>
          <Box color="white" padding="1rem" display="flex" sx={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px", backgroundColor: `${colors.mj_red}` }} justifyContent="center" alignItems="center">
            {action}
          </Box>
          <Box>
            <Typography display="inline-block" margin="1rem" textAlign="center">
              Voulez vous vraiment{" "}
              <Typography display="inline-block" fontWeight="bold">
                {action}
              </Typography>{" "}
            </Typography>
          </Box>
          {success ? (
            <Alert sx={{ margin: "0rem 0rem 1rem 0rem", textAlign: "center" }} severity="success">
              {success}
            </Alert>
          ) : null}
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Box margin="0 auto" display="flex" gap="1rem" alignItems="center" justifyContent="center">
            <Box onClick={() => (action === "payer la fiche de paie" ? payerFiche() : "")} margin="1rem 0rem" display="flex" alignItems="center" justifyContent="center">
              <Button variant="mj_primary">{action}</Button>
            </Box>
            <Box onClick={() => setOpen(false)} margin="1rem 0rem" display="flex" alignItems="center" justifyContent="center">
              <Button variant="mj_secondary">Annuler</Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default FicheDePaieDetails;
